import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AlertService } from 'app/services';
import { SalesService, UserSalesMessage } from 'app/services/sales.service';
import { SalesMessageModalComponentViewModel } from './sales-message-modal.viewmodel';

@Component({
	selector: 'sales-message-modal',
	templateUrl: 'sales-message-modal.html',
	
})
export class SalesMessageModalComponent {

	viewModel: SalesMessageModalComponentViewModel;

	@Input() closeCallback : (userId: number, messages: UserSalesMessage[]) => void;

    constructor(private salesService: SalesService, private alertService: AlertService) {		
        this.viewModel = new SalesMessageModalComponentViewModel(salesService, alertService);
    }

    open(userId: number, userFullName: string,	userJobTpText: string,	userCmpnyNm: string) {
        this.viewModel.open(userId, userFullName, userJobTpText, userCmpnyNm);
    }

    close() {
        if (this.closeCallback) {
            this.closeCallback(this.viewModel.userId, this.viewModel.messages);
        }
        this.viewModel.close();
    }
	
}


// WEBPACK FOOTER //
// ./src/app/components/sales/sales-message-modal.ts